import ApplicationResource from './ApplicationResource';
export const MEDIAS_MIME_TYPE_CONFIG = [{
  name: 'Images',
  type: 'image',
  subtype: null
}, {
  name: 'Vidéos',
  type: 'video',
  subtype: null
}, {
  name: 'Documents PDF',
  type: 'application',
  subtype: 'pdf'
}];
export default class AdminMediaResource extends ApplicationResource {
  static getMeta() {
    const url = this.url.bind(this);
    return this.detail().extend({
      url(param) {
        return url(param) + '/meta';
      },

      schema: {
        name: '',
        alt: ''
      }
    });
  }

  static updateMeta() {
    const url = this.url.bind(this);
    return this.partialUpdate().extend({
      url(param) {
        return url(param) + '/meta';
      },

      schema: this
    });
  }

  pk() {
    return this.id;
  }

}
AdminMediaResource.resource = '/admin/media';